export default class extends Controller {
  static targets = ["popup"];

  togglePopupDisplay(event) {
    if (this.hasPopupTarget && (event.target === this.popupTarget || this.popupTarget.contains(event.target))) {
      return;
    }
    if (this.hasPopupTarget) {
      this.closeDisplay(event);
    } else {
      App.Helpers.ajaxRequest({
        url: this.url,
        successHandler: (response => {
          const newEl = document.createElement('div');
          newEl.className = this.popupClassName
          newEl.dataset.target = `${this.identifier}.popup`
          newEl.innerHTML = response
          this.element.append(newEl);
        }).bind(this)
      })
    }
  }

  closeDisplay(event) {
    event.preventDefault()
    event.stopPropagation();
    this.element.removeChild(this.popupTarget);
  }

  get url() {
    return this.data.get('url');
  }

  get popupClassName() {
    return this.data.get("popup-class-name")
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/popup-fetch-controller.js